import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import SalesMarketing from "./salesMarketing/salesMarketing";
import Transactions from "./transactions/transactions";
import GrowthForecast from "./growthForecast/growthForecast";
import AnalyticDashboard from "./analyticDashboard/analyticDashboard";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { useShellNav } from "../../commonComponents/appShell/shellNav";
import {
  cancelIdlePrefetch,
  dispatchTabWaves,
  resetAggregateSessionForClient,
  scheduleIdlePrefetch,
} from "./analyticsAggregateFetch";
import { aggregateTabForNav } from "./analyticsTabMap";
import { resetLastPurchase } from "../../../store/features/portalManagement/portalManagementSlice";

const AnalyticsView = () => {
  const { selectedClient } = useAppSelector(
    (state: any) => state.portalManagement
  );
  const dispatch = useAppDispatch();
  const { selectedItemId, selectItem: handleNavigation } = useShellNav();

  // Wave session is module-level so tab switches stay warm. Re-committing the
  // same client (new selectedClient object, same customer_id) still has to
  // reset it: portalManagementSearchReset wipes the tiles, and without a
  // reset dispatchTabWaves would skip as "already fetched."
  useEffect(() => {
    if (!selectedClient?.customer_id) return;
    resetAggregateSessionForClient(selectedClient.customer_id);
  }, [selectedClient]);

  // Active tab: delta waves now. Landing also schedules idle prefetch of other
  // tabs + last_purchase_detail so cross-tab nav is usually warm.
  useEffect(() => {
    if (!selectedClient?.customer_id) return;
    const customerId = selectedClient.customer_id;
    const tab = aggregateTabForNav(selectedItemId);

    dispatchTabWaves({ dispatch, customerId, tab });
    scheduleIdlePrefetch({ dispatch, customerId, activeTab: tab });

    return () => {
      // Timers cancel on client change / unmount via the client effect.
    };
  }, [dispatch, selectedClient, selectedItemId]);

  // Clear X-partition lead cache when the selected client changes so a late
  // last_purchase_detail cannot export the previous client's rows.
  useEffect(() => {
    dispatch(resetLastPurchase());
    return () => {
      cancelIdlePrefetch();
    };
  }, [dispatch, selectedClient?.customer_id]);

  return (
    <Grid container>
      <Grid item xs={12}>
        {selectedItemId === "dashboard" && (
          <AnalyticDashboard
            handleNavigation={(event: string) => handleNavigation(event)}
          />
        )}
        {selectedItemId === "growthForecast" && <GrowthForecast />}
        {selectedItemId === "transactions" && <Transactions />}
        {selectedItemId === "salesmarketing" && <SalesMarketing />}
      </Grid>
    </Grid>
  );
};

export default AnalyticsView;
